




























import { PropType, toRef, ref, watch } from 'vue';
import { PostModel } from '../../../shared/models/post.model';
import PostHeader from './PostHeader.vue';
import PostComments from './PostComments.vue';
import PostBody from './PostBody.vue';
import PostAttachments from './PostAttachments.vue';
import { notificationAreas } from '../../../shared/enums/notificationAreas';
import { notificationTypes } from '../../../shared/enums/notificationTypes';
import * as dateUtil from '../../../shared/utils/dateUtil.js';
import { notificationEventTypes } from '../../../shared/enums/notificationEventTypes';
import { NotificationModel } from '../../../shared/models/notification.model';

export default {
  components: { PostAttachments, PostBody, PostComments, PostHeader },
  props: {
    post: { type: Object as PropType<PostModel>, required: true },
    previewMode: { type: Boolean, default: false },
    includesReportedComments: { type: Boolean, default: false },
    highlightedCommentId: { type: Number, default: null },
    notifications: { type: Array as PropType<NotificationModel[]>, default: () => [] },
  },
  emits: ['edit', 'delete', 'report'],
  setup(props) {
    const notifications = toRef(props, 'notifications');
    const isUnread = ref(false);

    isUnread.value = hasUnreadNotifications(notifications.value);

    function hasUnreadNotifications(notifications: NotificationModel[]) {
      return notifications.some(
        notification =>
          notification.notificationArea == notificationAreas.POSTS &&
          notification.postId == props.post.id &&
          notification.notificationEventType === notificationEventTypes.POST_SHARED_WITH_ME
      );
    }

    watch(
      () => notifications.value,
      (newValue, oldValue) => {
        const hasNewUnread = hasUnreadNotifications(newValue);
        const hasOldUnread = hasUnreadNotifications(oldValue ?? []);

        if (!hasNewUnread && hasOldUnread) {
          isUnread.value = true;
        }
      },
      { deep: true }
    );

    return {
      isUnread,
    };
  },
  computed: {
    hasNewComments() {
      return this.notifications.some(
        notification =>
          notification.notificationArea == notificationAreas.POSTS &&
          notification.notificationType === notificationTypes.BADGE &&
          notification.postId == this.post.id &&
          notification.notificationEventType === notificationEventTypes.NEW_POST_COMMENT
      );
    },
    canViewComments() {
      return this.post.allowComments;
    },
    isImportant() {
      if (!this.post.isImportant || this.post.isExpired) {
        return false;
      }
      const today = dateUtil.format(new Date());
      const isSameOrAfterImportantFrom =
        !this.post.importantFrom || dateUtil.isBefore(today, this.post.importantFrom, 'days') === false;
      const isSameOrBeforeImportantTo =
        !this.post.importantTo || dateUtil.isAfter(today, this.post.importantTo) === false;
      return isSameOrAfterImportantFrom && isSameOrBeforeImportantTo;
    },
    isExpired() {
      return this.post.isExpired === true;
    },
    isPlanned() {
      return this.post.isPublished === false;
    },
  },
  methods: {
    emitEdit() {
      this.$emit('edit', this.post.id);
    },
    emitDelete() {
      this.$emit('delete', this.post.id);
    },
    emitReport() {
      this.$emit('report', this.post.id);
    },
  },
};
